(() => {
  const STORAGE_KEY = 'd2d_attribution';

  const ATTRIBUTION_KEYS = [
    'gclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  function getStoredAttribution() {
    try {
      return JSON.parse(
        window.sessionStorage.getItem(STORAGE_KEY)
      ) || {};
    } catch {
      return {};
    }
  }

  function storeAttribution(values) {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(values)
      );
    } catch {
      // The current page's values still work without storage.
    }
  }

  const attribution = getStoredAttribution();
  const currentParameters = new URLSearchParams(window.location.search);

  ATTRIBUTION_KEYS.forEach((key) => {
    const value = currentParameters.get(key);

    if (value && !attribution[key]) {
      attribution[key] = value;
    }
  });

  storeAttribution(attribution);

  function decorateAppLink(link) {
    if (!link) return;

    let destination;

    try {
      destination = new URL(
        link.getAttribute('href'),
        window.location.href
      );
    } catch {
      return;
    }

    if (destination.hostname.toLowerCase() !== 'dermtodoor.app') {
      return;
    }

    ATTRIBUTION_KEYS.forEach((key) => {
      const value = attribution[key];

      if (value && !destination.searchParams.has(key)) {
        destination.searchParams.set(key, value);
      }
    });

    link.href = destination.toString();
  }

  // Update all app links already on the page.
  document
    .querySelectorAll('a[href]')
    .forEach(decorateAppLink);

  // Also handle links added dynamically after the page loads.
  document.addEventListener(
    'click',
    (event) => {
      const element =
        event.target instanceof Element ? event.target : null;

      decorateAppLink(element?.closest('a[href]'));
    },
    true
  );
})();